import { memo, SyntheticEvent, useCallback } from 'react';
import { Tab as MUITab, TabProps as MUITabProps } from '@mui/material';
import { B1, S4 } from '../../../../theme';
import { mergeSX } from '../../../../services/helpers';
import { TYPOGRAPHY_SUBTITLE1 } from '../../../Typography';

interface IBuildSXParams {
  maxWidth?: number | string;
  minWidth: number | string;
  padding: number | string;
}

interface ITabProps extends Omit<MUITabProps, 'onClick'>, Partial<IBuildSXParams> {
  onClick?: (event: SyntheticEvent, value: ITabProps['value']) => void;
}

const buildSX = ({ maxWidth, padding, minWidth }: IBuildSXParams) => ({
  '&.MuiTab-root': {
    padding,
    maxWidth: maxWidth ?? null,
    minWidth,
    minHeight: '38px',
    ...TYPOGRAPHY_SUBTITLE1,
    color: S4,
    textTransform: 'none',
    '& .MuiAvatar-root': {
      svg: {
        stroke: S4,
      },
    },
    '&.Mui-selected': {
      svg: {
        stroke: B1,
      },
    },
  },
});

const Tab = (props: ITabProps) => {
  const {
    children,
    maxWidth,
    minWidth = '90px',
    padding = '8px',
    onClick,
    value,
    sx,
    ...restProps
  } = props;

  const handleClick = useCallback((event: SyntheticEvent) => {
    if (onClick) {
      onClick(event, value);
    }
  }, [onClick, value]);

  return (
    <MUITab
      sx={mergeSX(buildSX({ maxWidth, padding, minWidth }), sx)}
      onClick={handleClick}
      value={value}
      {...restProps}
    >
      {children}
    </MUITab>
  );
};

export default memo(Tab);
